<template>
  <div class="d-popover-default-arrow">
    <svg
      width="32"
      height="8"
      viewBox="0 0 24 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 0.5L0 1.5C4 1.5, 5.5 3, 7.5 5S10,8 12,8S14.5 7, 16.5 5S20,1.5 24,1.5L24 0.5L0 0.5z"
        :fill="borderColor"
      />
      <path
        d="M0 0L0 1C4 1, 5.5 2, 7.5 4S10,7 12,7S14.5  6, 16.5 4S20,1 24,1L24 0L0 0z"
        :fill="backgroundColor"
      />
    </svg>
  </div>
</template>
<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    props: {
      borderColor: {
        type: String,
        default: 'var(--color-border-default-opaque)',
      },
      backgroundColor: {
        type: String,
        default: 'var(--color-white)',
      },
    },
  })
</script>
